import { darkTheme as theme } from '../dark'

export const MuiToggleButton = {
  root: {
    lineHeight: '20px',
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.light,
    border: '1px solid ' + theme.palette.primary.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    },
    '&.Mui-selected': {
      color: 'inherit',
      border: '1px solid ' + theme.palette.secondary.main,
      backgroundColor: theme.palette.primary.darkest,
      '&:hover': {
        backgroundColor: theme.palette.primary.main + '!important'
      }
    }
  },
  label: {
    height: 'inherit'
  },
  sizeSmall: {
    height: 20
  }
}
